module.exports = __webpack_public_path__ + "img/laydefault.a65a5318.png";